import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class UserService {
  private  baseUrl = environment.baseUrl;
  constructor(private http:HttpClient) {
    console.log('Environment Name: ', environment.envName);
  }

  // User Login 
  login(userData:any) {
    return this.http.post(`${this.baseUrl}/api/Login/Validate`,userData)
          .pipe(
            catchError(this.handleError)
          );
  }

  // User sso 
  sso(userData:any) {
      return this.http.get(`${this.baseUrl}/api/sso/${userData}`)
            .pipe(
              catchError(this.handleError)
            );
    }

  // User Sign Up
  signup(userData:any){
    return this.http.post(`${this.baseUrl}/api/Login/SignUp`,userData)
              .pipe(
                catchError(this.handleError)
              );
  }

  private handleError(error:HttpErrorResponse) {
    if(error.error instanceof ErrorEvent) {
      console.error('An error occured', error.error.message);
    } else {
      console.error(
        `Backend returned code ${error.status}`
      );
    }
    return throwError(error.error);
  }

  logout() {    
    return this.http.get(`${this.baseUrl}/api/Logout`)
    .pipe(
      catchError(this.handleError)
    );
   }

}
